"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FormWrapper;
const jsx_runtime_1 = require("react/jsx-runtime");
const useHookForm_1 = require("../../hooks/useHookForm");
const Form_1 = __importDefault(require("../../components/Form"));
function FormWrapper({ schema, defaultValues = {}, children, onSubmit }) {
    const form = (0, useHookForm_1.useHookForm)({
        defaultValues,
        schema,
    });
    return ((0, jsx_runtime_1.jsxs)(Form_1.default, { form: form, onSubmit: onSubmit, children: [children, (0, jsx_runtime_1.jsx)("button", { type: "submit", children: "Submit" })] }));
}
//# sourceMappingURL=FormWrapper.js.map